import { classnames } from 'tailwindcss-classnames';
import { TcDirectoryEligibilityProps } from '../_types';
import { MissingDataSource } from 'components/helpers/EditingHelpText';

const PediatricEligibilityTransferDetails = ({
  fields,
}: Pick<TcDirectoryEligibilityProps, 'fields'>) => {
  if (!fields) {
    return <MissingDataSource />;
  }
  return (
    <ul className={classnames('pt-2')}>
      {fields.pedTx?.value && (
        <li className={classnames('list-disc', 'list-inside')}>
          <span>Will admit pediatric patients who transferred into the program</span>
          {fields?.pedAgeLimit?.value && (
            <span> if they are under age {fields.pedAgeLimit.value}</span>
          )}
        </li>
      )}
      {fields?.adultAfterPed?.value && (
        <li className={classnames('list-disc', 'list-inside')}>
          <span>Will accept adult patients who were transplanted as a child at another center</span>
          {fields.adultAfterPedTxLimit?.value && (
            <span> up to age {fields.adultAfterPedTxLimit.value}</span>
          )}
        </li>
      )}
    </ul>
  );
};

export default PediatricEligibilityTransferDetails;
